import { Component } from '@theme/component';

/**
 * Dedicated mega menu owner rendered from section.
 *
 * @extends {Component}
 */
class HeaderMegaMenu extends Component {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener('header-mega-menu:activate', this.#onActivate);
    document.addEventListener('header-mega-menu:deactivate', this.#onDeactivate);
    this.addEventListener('pointerleave', this.#onPointerLeave);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('header-mega-menu:activate', this.#onActivate);
    document.removeEventListener('header-mega-menu:deactivate', this.#onDeactivate);
    this.removeEventListener('pointerleave', this.#onPointerLeave);
  }

  /**
   * @param {string} handle
   */
  setActiveHandle(handle) {
    const hybrid = this.querySelector('mega-menu-hybrid');
    if (!(hybrid instanceof HTMLElement) || !('setActiveHandle' in hybrid)) return;
    /** @type {{ setActiveHandle: (next: string) => void }} */ (hybrid).setActiveHandle(handle);
  }

  open() {
    this.hidden = false;
    this.dataset.hybridOpen = 'true';
  }

  close() {
    this.dataset.hybridOpen = 'false';
    this.hidden = true;
  }

  /** @param {Event} event */
  #onActivate = (event) => {
    const customEvent = /** @type {CustomEvent<{handle?: string}>} */ (event);
    const handle = customEvent.detail?.handle;
    if (handle) this.setActiveHandle(handle);
    this.open();
  };

  #onDeactivate = () => {
    this.close();
  };

  #onPointerLeave = () => {
    document.dispatchEvent(new CustomEvent('header-mega-menu:request-close'));
  };
}

if (!customElements.get('header-mega-menu')) {
  customElements.define('header-mega-menu', HeaderMegaMenu);
}
